/** NNI affiché / comparé de façon stable (trim + majuscules). */
export function normalizeOrgNni(value: string | undefined | null): string {
  return String(value ?? '').trim().toUpperCase()
}
